import { createApp } from "vue";
import router from "../router/router";
import store from "../store/store";
import App from "./App.vue";
import "maz-ui/styles";
import vuetify from "../plugins/vuetify";
import "../plugins/gmap";
import mixins from "../mixins/lazyLoadingHack";
import * as utilFunction from "../utils";
import VueSmoothScroll from "v-smooth-scroll";
import "ag-grid-enterprise";
import "../registerServiceWorker";
import { ApiVuePlugin } from "../api/ApiVuePlugin";
import api from "../api/api";
import "@/assets/styles/main.scss";
import "swiper/css";
import "swiper/css/navigation";
import * as Sentry from "@sentry/vue";
import { API } from "../api/endpoints";
import axios from "../middleware/axios";

const app = createApp(App as any);
app.use(store);

app.use(router);
app.use(VueSmoothScroll);
app.use(ApiVuePlugin);
app.mixin(mixins);
app.use(vuetify);
app.config.globalProperties.$currency = utilFunction.currency
app.config.globalProperties.$shortDate = utilFunction.shortDate
app.config.globalProperties.$mediumDate = utilFunction.mediumDate
app.config.globalProperties.$fullDate = utilFunction.fullDate
app.config.globalProperties.$simpleTime = utilFunction.simpleTime
app.config.globalProperties.$api = api;

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get("confirm")) {
  axios.post(API.USER_EMAIL_CONFIRMATION, { token: urlParams.get("confirm") }).then(response => {
      console.log("User email confirmed")
  })
}

if (urlParams.get("mgrToken")) {
  localStorage.setItem("mgrToken", urlParams.get("mgrToken"));
  localStorage.setItem("mgrUser", urlParams.get("mgrUser"));
  localStorage.setItem("mgrOrganizationID", urlParams.get("mgrOrganizationID"));

  window.location.replace(location.pathname);
}

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

app.mount("#app");
